module.exports = __webpack_public_path__ + "static/img/payway2.0968b8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newdownload/payway2.png
// module id = 0POO
// module chunks = 0